const privacyPolicy = [
    { 
        id: "overview", 
        title: "1. Overview", 
        content: "At [Your Company Name], we prioritize your privacy and are committed to safeguarding the data you entrust with us. This Privacy Policy outlines how we collect, process, and protect your personal and usage data when using our platform. By accessing and using our services, you agree to comply with this Privacy Policy."
    },
    { 
        id: "data-privacy", 
        title: "2. Data Privacy", 
        content: "We collect both personal and non-personal data to improve our AI-driven services. The data collected includes, but is not limited to:",
        list: [
            "User registration information",
            "Interaction data with AI tools and features",
            "Payment, billing, and subscription details",
            "Customer support and feedback data"
        ]
    },
    { 
        id: "terms-of-service", 
        title: "3. Terms of Service", 
        content: "Our Terms of Service govern the use of the AI platform and its tools. By accessing the platform, you agree to these terms, which encompass acceptable use, licensing, limitations of liability, and user responsibilities."
    },
    { 
        id: "user-rights", 
        title: "4. User Rights", 
        content: "As a user, you hold certain rights over your data, including:",
        list: [
            "The right to access and delete your personal data",
            "The right to withdraw consent for data processing at any time",
            "The right to correct any inaccuracies in your data"
        ]
    },
    { 
        id: "data-security", 
        title: "5. Data Security", 
        content: "We take the security of your data very seriously. We implement industry-standard security protocols to protect your information from unauthorized access, misuse, alteration, and destruction."
    },
    { 
        id: "cookies", 
        title: "6. Cookies", 
        content: "We use cookies and similar technologies to enhance user experience and track usage patterns on our platform. These help us improve features, content, and performance of the service."
    },
    { 
        id: "third-party", 
        title: "7. Third-Party Services", 
        content: "We may integrate third-party services, such as payment gateways and cloud providers, to enhance platform functionality. These third-party services may process your data independently, and we encourage you to review their privacy policies for more information."
    },
    { 
        id: "data-storage", 
        title: "8. Data Storage", 
        content: "Your data is stored securely on our servers using advanced encryption methods. We retain your data as long as needed to deliver our services or comply with legal obligations. You can request data deletion or transfer options if you choose to discontinue using our services."
    },
    { 
        id: "data-transfers", 
        title: "9. Data Transfers", 
        content: "In some cases, your data may be transferred to countries outside your region for processing. We ensure these transfers comply with privacy laws and maintain a high standard of data protection."
    },
    { 
        id: "policy-updates", 
        title: "10. Policy Updates", 
        content: "We may update this Privacy Policy periodically to reflect changes in our services or legal requirements. We will notify you of significant updates and provide the latest version on this page."
    }
];

export default privacyPolicy;